import { useContext } from 'react';
import { TabContext } from '../../../Context/TabContext';
import './Menu.css';
import MenuItems from './MenuItems/MenuItems';

function Menu(props) {
  const { items, open, closeMenu } = props;
  const tabContext = useContext(TabContext);

  const openItem = (item) => {
    tabContext.addTab(item);
    closeMenu();
  };
  const haveReports = (items) => {
    if (items.length > 0) {
      let reports = false;
      items.forEach((item) => {
        item.items.forEach((item) => {
          if (item.document === true) {
            reports = true;
          }
        });
      });
      return reports;
    }
    return false;
  };

  const reports = haveReports(items);
  return (
    <div
      className="menu_container"
      style={{ transform: `translateX(${open ? '0' : '-150%'})` }}
    >
      <div className="menu_items">
        {items.map((item) => (
          <MenuItems key={item.title} item={item} openItem={openItem} />
        ))}
      </div>
      {reports && (
        <div style={{ width: '100%', height: '500px' }}>
          <h1 className="reports_title">REPORTS</h1>
          <div className="menu_items report_items">
            {items.map((item) => (
              <MenuItems
                reports
                key={item.title}
                item={item}
                openItem={openItem}
              />
            ))}
          </div>
        </div>
      )}
      <span className="closeMenu" onClick={closeMenu}>
        <i className="fas fa-times" />
      </span>
    </div>
  );
}

export default Menu;
